import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../api/client';
import { getRememberedAuthRedirect } from '../utils/authRedirect';

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const hasSubmittedRef = useRef(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const redirect = getRememberedAuthRedirect();
  const loginPath = redirect ? `/login?redirect=${encodeURIComponent(redirect)}` : '/login';

  useEffect(() => {
    if (hasSubmittedRef.current) {
      return;
    }

    hasSubmittedRef.current = true;

    const token = searchParams.get('token') || searchParams.get('code');

    if (!token) {
      setError('Missing verification token in the URL.');
      setLoading(false);
      return;
    }

    const verify = async () => {
      try {
        await api.verifyEmail(token);
        setSuccess(true);
      } catch (err: any) {
        setError(err.message || 'Email verification failed. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    void verify();
  }, [searchParams]);

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h1>Verify Email</h1>
        <p className="auth-subtitle">Confirming your email address...</p>

        {loading && <div className="loading">Verifying your email...</div>}
        {!loading && success && (
          <div className="success">
            Your email has been verified. You can now continue using your account.
          </div>
        )}
        {!loading && error && <div className="error">{error}</div>}

        {!loading && (
          <p className="auth-link">
            <Link to={loginPath}>Go to login</Link>
          </p>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
